import React from 'react';
import { Badge, Card, Row, Col } from 'react-bootstrap';

/**
 * Component to display ticker update status information
 * Shows WebSocket and polling status, update counts, and last update source
 */
const TickerUpdateStatus = ({ 
  isWebSocketConnected, 
  isPollingActive, 
  lastUpdateSource, 
  totalUpdates, 
  webSocketUpdates, 
  pollingUpdates,
  lastUpdateTime,
  className = ""
}) => {
  return (
    <Card className={`mb-3 ${className}`} style={{ fontSize: '0.875rem' }}>
      <Card.Header className="py-2">
        <h6 className="mb-0">Ticker Update Status</h6>
      </Card.Header>
      <Card.Body className="py-2">
        <Row className="g-3 h-100">
          {/* Left Column: Connection Status */}
          <Col md={6}>
            <div className="h-100 d-flex flex-column justify-content-between">
              <div className="mb-3">
                <h6 className="text-muted mb-2">Connection Status</h6>
                <div className="mb-2">
                  <div className="d-flex align-items-center justify-content-between">
                    <span className="fw-medium">WebSocket:</span>
                    <Badge 
                      bg={isWebSocketConnected ? 'success' : 'warning'}
                      className="text-nowrap"
                    >
                      {isWebSocketConnected ? 'Connected' : 'Disconnected'}
                    </Badge>
                  </div>
                </div>
                <div className="mb-2">
                  <div className="d-flex align-items-center justify-content-between">
                    <span className="fw-medium">Polling:</span>
                    <Badge 
                      bg={isPollingActive ? 'info' : 'secondary'}
                      className="text-nowrap"
                    >
                      {isPollingActive ? 'Active' : 'Inactive'}
                    </Badge>
                  </div>
                </div>
                <div>
                  <div className="d-flex align-items-center justify-content-between">
                    <span className="fw-medium">Last Source:</span>
                    <Badge 
                      bg={lastUpdateSource === 'webSocket' ? 'success' : lastUpdateSource === 'polling' ? 'info' : 'secondary'}
                      className="text-nowrap"
                    >
                      {lastUpdateSource || 'None'}
                    </Badge>
                  </div>
                </div>
              </div>
            </div>
          </Col>

          {/* Right Column: Update Statistics */}
          <Col md={6}>
            <div className="h-100 d-flex flex-column justify-content-between">
              <div className="mb-3">
                <h6 className="text-muted mb-2">Update Statistics</h6>
                <div className="mb-2">
                  <div className="d-flex align-items-center justify-content-between">
                    <span className="fw-medium">Total Updates:</span>
                    <Badge bg="primary" className="text-nowrap">
                      {totalUpdates || 0}
                    </Badge>
                  </div>
                </div>
                {(webSocketUpdates !== undefined || pollingUpdates !== undefined) && (
                  <>
                    <div className="mb-2">
                      <div className="d-flex align-items-center justify-content-between">
                        <span className="fw-medium">WebSocket Updates:</span>
                        <Badge bg="success" className="text-nowrap">
                          {webSocketUpdates || 0}
                        </Badge>
                      </div>
                    </div>
                    <div className="mb-2">
                      <div className="d-flex align-items-center justify-content-between">
                        <span className="fw-medium">Polling Updates:</span>
                        <Badge bg="info" className="text-nowrap">
                          {pollingUpdates || 0}
                        </Badge>
                      </div>
                    </div>
                    <div>
                      <div className="d-flex align-items-center justify-content-between">
                        <span className="fw-medium">Last Update:</span>
                        <span className="text-muted small">
                          {lastUpdateTime ? lastUpdateTime.toLocaleTimeString() : 'Never'}
                        </span>
                      </div>
                    </div>
                  </>
                )}
              </div>
            </div>
          </Col>
        </Row>
      </Card.Body>
    </Card>
  );
};

export default TickerUpdateStatus;
